import React from 'react';
import PropTypes from 'prop-types';

import ConditionalComponent from './ConditionalComponent';

export default class CollectionSummary extends React.Component {
    static propTypes = {
        collectionSummary: PropTypes.string,
        isEditMode: PropTypes.bool.isRequired,
    };

    render() {
        const { collectionSummary, isEditMode } = this.props;

        return (
            <ConditionalComponent
                shouldRender={collectionSummary && !isEditMode}
                containerClassName="
                    eds-text-color--ui-900
                    eds-text-weight--regular
                    eds-text-bl
                "
            >
                {collectionSummary}
            </ConditionalComponent>
        );
    }
}
